import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Headers from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';
import s11 from './Component/s13.png';
import s14 from './Component/s14.png';

function BlindsNShutters() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <Headers />

      <section
        className="relative bg-cover bg-center"
        style={{ backgroundImage: `url(${s11})` }}
      >
        <div className="absolute inset-0 bg-[#803333]/80" />
        <div className="relative container mx-auto px-4 py-14 md:py-20 text-center text-white">
          <h1 className="text-3xl md:text-4xl font-bold mb-2 tracking-tight">
            Blinds & Shutters
          </h1>
          <p className="text-white/85 text-sm md:text-base mb-6 max-w-xl mx-auto">
            Wide variety of styles to upgrade your windows
          </p>
          <a
            href="/free-estimate"
            className="inline-flex items-center gap-2 bg-white text-[#803333] font-semibold text-sm px-5 py-2.5 rounded-lg no-underline hover:bg-white/90 transition-colors"
          >
            Request an Estimate
            <i className="bi bi-arrow-right" />
          </a>
        </div>
      </section>

      <section className="container mx-auto px-4 py-10 md:py-14">
        <div className="row g-4 g-lg-5 align-items-start">
          <div className="col-lg-6">
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              <Request />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-8 h-100">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
                Is it time to upgrade your windows?
              </h2>
              <p className="text-sm font-medium text-[#803333] mb-5">
                Featuring eclipse shutters and blinds, wood, woven, soft shades, vertical, pleated, solar
              </p>
              <img
                src={s14}
                alt="Blinds and shutters styles"
                className="w-full h-auto rounded-xl mb-6"
              />
              <a
                href="/free-estimate"
                className="inline-flex items-center gap-2 bg-[#803333] text-white font-semibold text-sm px-5 py-2.5 rounded-lg no-underline hover:bg-[#6a2a2a] transition-colors"
              >
                Request an Estimate
                <i className="bi bi-arrow-right" />
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default BlindsNShutters;
